import { render, staticRenderFns } from "./JavaView.vue?vue&type=template&id=7e635428&scoped=true&"
import script from "./JavaView.vue?vue&type=script&lang=js&"
export * from "./JavaView.vue?vue&type=script&lang=js&"
import style0 from "./JavaView.vue?vue&type=style&index=0&id=7e635428&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e635428",
  null
  
)

export default component.exports